import { myPageAPI, storeAPI } from '@/common/service/ApiList';
import ServiceExec from '@/common/utils/ServiceExec';
import { asFormData } from '@/common/utils/ServiceSupport';

export default {
  async fetchReviewList({ state, commit }, payload) {
    const { page, totalPage, limit } = state.pageInfo;

    const { data, status } = await ServiceExec.get(myPageAPI.review_list, {
      page,
      userNo: payload.userNo
    });
    if (!data) return false;
    const { pageInfo, list } = data;

    commit('setPageInfo', pageInfo);
    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setList', list ?? []);
    return data;
  },

  async fetchStoreReviewList({ state, commit }, payload) {
    const { page, limit, totalPage } = state;
    if (page > totalPage) return;

    const { data } = await ServiceExec.get(storeAPI.store_reviews, {
      page: page,
      limit: limit,
      storeNo: payload.storeNo,
      reviewOrderCondition: payload.condition
    });
    const { list, pageInfo } = data;
    commit('setPage', page + 1);
    commit('setTotalPage', pageInfo?.totalPage ?? 2);
    commit('setStoreReviewList', list ?? []);
    return data;
  },

  async save({ state, commit }, payload) {
    const { data, status } = await ServiceExec.post(
      myPageAPI.review_save,
      asFormData(payload)
    );

    return data;
  },

  async delete({ state }, reviewNo) {
    const { data, status } = await ServiceExec.delete(
      myPageAPI.review_delete(reviewNo)
    );
    if (status === 200) return data;
  }
};
